import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { getProductTypeFromCluster } from "components/core/head/products-service";
const BIGBRAIN_SCRIPT_URL = process.env.BIGBRAIN_SCRIPT_URL;
const BIGBRAIN_URL = process.env.BIGBRAIN_ENDPOINT || "//data.bigbrain.me";
class BigBrainScript extends PureComponent {
    renderBigBrainTracker(template, isProduction, pageType, clusterId, subClusterId, preventPageView, createVisitor, crossDomain, emitVisitorId, emitTargetOrigin, segmentsList, pageProductId, exactPageAbTest, crossOriginLocaleAbTest) {
        const clusterIdToTrack = clusterId ? `${clusterId}${subClusterId ? `,${subClusterId}` : ""}` : "undefined";
        const exactPageAbTestTrack = exactPageAbTest ? `BigBrain('track', "${exactPageAbTest.name}", { ab_test: "${exactPageAbTest.variant}" });` : "";
        const crossOriginAbTestTrack = crossOriginLocaleAbTest ? `BigBrain('track', "${crossOriginLocaleAbTest.name}", { ab_test: "${crossOriginLocaleAbTest.variant}" });` : "";
        return `
      var brand_name = 'monday.com';
      var template = '${template}';

      function add_general_event_props(args) {
        event_props = {};
        if(args.length == 3) {
          event_props = args[2];
        }

        event_props['timestamp'] = parseInt(new Date().getTime()/1000);
        event_props["source"] = event_props["source"] || "monday_homepage";
        event_props["group"] = "website";

        if (args.length == 2) {
          args.push(event_props);
        }
        else {
          args[2] = event_props;
        }
        return args;
      }

      if (${isProduction}) {
        window.BigBrainQ = window.BigBrainQ || [];
        window.BigBrain = window.BigBrain || function(){
          args = Array.prototype.slice.call(arguments)
          if(args[0] == 'track'){
            args = add_general_event_props(args)
          }
          window.BigBrainQ.push(args);
        };

        (function(d,u,callback){
          if (window.BigBrainInit) return;
          window.BigBrainInit = true;
          var s = d.createElement('script');
          s.type = 'text/javascript'
          s.src = u;
          s.async = true;
          s.onreadystatechange = s.onload = function(){
            var st = s.readyState;
            if (!callback.done && (!st || /loaded|complete/.test(st))) {
              callback.done = true;
              callback();
            }
          };
          (d.body || d.head).appendChild(s);
        })(document, '${BIGBRAIN_SCRIPT_URL}', function() { 
            window.BigBrain = new BigBrainTracker({bigbrain_url: '${BIGBRAIN_URL}', send_immediately: true, create_visitor: ${createVisitor}, is_tracker_cross_domain: ${!!crossDomain}, emit_visitor_id: ${!!emitVisitorId}, emit_target_origin: "${emitTargetOrigin}"});
        });

      } else {
        window.BigBrain = function() {
          args = Array.prototype.slice.call(arguments)
          if(args[0] == 'track' || args[0] == 'set_utm_cluster_id'  ||  args[0] == 'set_utm_locale_id') {
            args = add_general_event_props(args)
            argsn = args.map(function(t) {
              if (typeof(t) === 'object')
                return JSON.stringify(t);
              else
                return t;
            });
            console.info(argsn);
          }
        }
      }

      if (${!preventPageView}) {
        var type = document.getElementsByTagName('body')[0].dataset.pageType || '${pageType}';
        if (type === undefined || (typeof (type) == 'string' && type.length == 0) || type == 'homepage'){
          type = 'homepage';
        } else {
          type = '${pageType}';
        }
        window.visitGuid = window.visitGuid || Math.ceil(Math.random() * 10000000);
        var options = {
          kind: location.pathname, 
          source: type, info2: template || "", 
          info3: location.href, 
          direct_object: window.visitGuid, 
          info1: "${clusterIdToTrack}", 
          data: {
            segments: "${segmentsList}",
            windowInnerWidth: window.innerWidth,
            windowInnerHeight: window.innerHeight,
            product: "${pageProductId || getProductTypeFromCluster(clusterId) || "undefined"}"
          }
        };
        BigBrain('track', 'page_view', options);
        ${exactPageAbTestTrack}
        ${crossOriginAbTestTrack}
      }
  `;
    }
    render() {
        const { template, isProduction, pageType, clusterId, subClusterId, preventPageView, createVisitor, crossDomain, emitVisitorId, emitTargetOrigin, segmentsList, pageProductId, exactPageAbTest, crossOriginLocaleAbTest } = this.props;
        return /*#__PURE__*/ _jsx("script", {
            dangerouslySetInnerHTML: {
                __html: this.renderBigBrainTracker(template, isProduction, pageType, clusterId, subClusterId, preventPageView, createVisitor, crossDomain, emitVisitorId, emitTargetOrigin, segmentsList, pageProductId, exactPageAbTest, crossOriginLocaleAbTest)
            }
        });
    }
}
export { BigBrainScript as default };
BigBrainScript.defaultProps = {
    pageType: "homepage",
    createVisitor: true
};
